export const PRIMARY_FIELDS = {
  drawdown: [
    "max_overall_drawdown_percentage",
    "max_daily_drawdown_percentage",
    "max_position_drawdown_percentage",
    "global_max_overall_drawdown_percentage",
    "global_max_daily_drawdown_percentage",
    "user_daily_threshold_percent",
    "user_overall_threshold_percent",
    "user_position_max_drawdown_percent",
  ],
  monitoring: [
    "enable_overall_drawdown_monitoring",
    "enable_daily_drawdown_monitoring",
    "enable_position_drawdown_monitoring",
    "close_position_on_max_drawdown_breach",
  ],
  pip: [
    "enable_pip_based_sl",
    "enable_pip_based_tp",
    "default_sl_distance_pips",
    "default_tp_distance_pips",
  ],
  ttl: [
    "enable_position_ttl",
    "max_position_alive_seconds",
    "auto_close_on_ttl_expiration",
    "allow_ttl_extension",
  ],
};